import { assignInput, BaseModel } from '../base.model';

export class ManPowerRequisitionModel extends BaseModel {
  JobClassId: number = null;
  StartDate: Date = null;
  EndDate: Date = null;
  EmployeeId: string = null;
  ProspectId: string = null;
  CheckForOtherManPower: boolean = false;
  ManPowerReqDetailId: string = null;

  constructor(o: any = null) {
    super(o);
    // WI 35894: re-apply o after this class's field initializers (see assignInput in base.model.ts).
    assignInput(this, o);
    if (o) {
      this.StartDate = o.StartDate ? new Date(o.StartDate) : null;
      this.EndDate = o.EndDate ? new Date(o.EndDate) : null;
    }
  }
}
